"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateZodiosPaginatedResponseSchema = generateZodiosPaginatedResponseSchema;
const zod_1 = require("zod");
function generateZodiosPaginatedResponseSchema(docSchema, customKeys) {
    return zod_1.z
        .object({
        docs: zod_1.z.array(docSchema),
        total: zod_1.z.number(),
        page: zod_1.z.number(),
        lastPage: zod_1.z.number(),
        ...customKeys,
    })
        .required();
}
//# sourceMappingURL=response.js.map